import { getStoreDispatchListData } from '@/utils/functions'
export default {
  data () {
    return {
      allPriceKey: 'allPrice', // 页面中根据实际使用重新定义这个key 字符串
      discountList: []
    }
  },
  async created () {
    this.getDiscountList()
  },
  computed: {
    discountMoney () {
      if (this.discountList.length == 0) return 0
      let discount = 1
      let allPrice = this[this.allPriceKey]
      this.discountList.forEach(item => {
        if (item.limit < allPrice && discount > item.sale) discount = item.sale
      })
      let data = (1 - discount) * (allPrice - 0) - 0
      return data
    }
  },
  methods: {
    async getDiscountList () {
      this.discountList = await getStoreDispatchListData.call(this, 'dataList.discountList', 'dataList/getDiscountList')
    }
  }
}